// 請求書PDFの作成（LMS-822）
// PDFはキューで作るので、作成中は作成状況を問い合わせ、終わったら画面を読み直してダウンロードボタンを出す。
// 作成依頼のボタンは、押したら次の画面が出るまで押せないようにする（同じ請求書の作成は 1 つしか受け付けないが、待っている間の連打を減らす）
// 初めの 2 分は 3 秒ごと（ふだんは十数秒でできる）、その後は 15 秒ごとに問い合わせる（月初は順番待ちで長くかかるため、間隔を延ばして問い合わせを減らす）
const POLL_INTERVAL_MS = 3000;
const SLOW_POLL_INTERVAL_MS = 15000;
const FAST_POLL_DURATION_MS = 2 * 60 * 1000;
// サーバー側は作成待ち 60 分（InvoiceExport::PENDING_STALE_MINUTES）・作成中 15 分で止まったとみなし、作成中ではないと返す（読み直すと作成ボタンが出る）。
// それより少し長く問い合わせ、それでも終わらないときだけ問い合わせをやめる
const MAX_POLL_DURATION_MS = 65 * 60 * 1000;

document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('[data-invoice-export-form]').forEach(function(form) {
        form.addEventListener('submit', function() {
            const button = form.querySelector('button[type="submit"]');
            if (button) {
                button.dataset.label = button.textContent;
                button.disabled = true;
                button.textContent = '受け付けています…';
            }
        });
    });

    const status = document.querySelector('[data-invoice-export-status-url]');
    if (!status) {
        return;
    }

    const started_at = Date.now();
    const poll = function() {
        fetch(status.dataset.invoiceExportStatusUrl, {
            headers: { 'Accept': 'application/json' },
            credentials: 'same-origin',
        })
            .then(function(response) {
                return response.ok ? response.json() : null;
            })
            .then(function(data) {
                if (data && !data.in_progress) {
                    window.location.reload();
                    return;
                }
                next();
            })
            // 一時的な通信エラーは、次の問い合わせで回復する
            .catch(next);
    };
    const next = function() {
        const elapsed_ms = Date.now() - started_at;
        if (elapsed_ms >= MAX_POLL_DURATION_MS) {
            status.textContent = '請求書の作成に時間がかかっています。しばらくしてから画面を読み直してください。';
            return;
        }
        setTimeout(poll, elapsed_ms < FAST_POLL_DURATION_MS ? POLL_INTERVAL_MS : SLOW_POLL_INTERVAL_MS);
    };

    setTimeout(poll, POLL_INTERVAL_MS);
});

// ブラウザの「戻る」で表示したとき（bfcache）に、押せないままのボタンを戻す
window.addEventListener('pageshow', function(event) {
    if (!event.persisted) {
        return;
    }
    document.querySelectorAll('[data-invoice-export-form] button[type="submit"]:disabled').forEach(function(button) {
        button.disabled = false;
        if (button.dataset.label) {
            button.textContent = button.dataset.label;
        }
    });
});
